import OptimizedPortfolioAllocationTable from'./OptimizedPortfolioAllocationTable';export default OptimizedPortfolioAllocationTable;